import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Tooltip } from 'antd';

import { Attach, Info } from 'icons';
import { Namespace } from 'enums';
import { FILE_ATTACHMENT_EXTENSIONS, FILE_ATTACHMENT_MAX_SIZE_MB, FILE_ATTACHMENT_MAX_COUNT } from 'constants-module';

import styles from './UploadButton.module.scss';

export interface UploadButtonProps {
  id: string;
  name: string;
  label: string;
  accept?: string;
  addAttachment: (value: any) => void;
}

export const UploadButton = ({
  id,
  name,
  label,
  accept = FILE_ATTACHMENT_EXTENSIONS,
  addAttachment,
}: UploadButtonProps) => {
  const { t } = useTranslation(Namespace.CompensationForm);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.btnContainer}>
      <input
        ref={inputRef}
        className={styles.uploadInput}
        accept={accept}
        id={id}
        multiple
        type="file"
        name={name}
        onChange={(event) => {
          addAttachment(event?.currentTarget?.files ? [...event.currentTarget.files] : null);
        }}
      />
      <Button className={styles.uploadBtn} icon={<Attach />} onClick={() => inputRef.current!.click()}>
        {label}
      </Button>
      <Tooltip
        title={
          <>
            <div>{t('attachmentCountHelper', { count: FILE_ATTACHMENT_MAX_COUNT })}</div>
            <div>{t('attachmentFileSizeHelper', { size: FILE_ATTACHMENT_MAX_SIZE_MB })}</div>
            <div>{t('attachmentFileExtensionHelper', { extensions: accept })}</div>
            <div>{t('attachmentStorageInfo')}</div>
          </>
        }
      >
        <Info />
      </Tooltip>
    </div>
  );
};
